











import { Component, Vue } from "vue-property-decorator";
import ItemData from "../model/ItemData";
import item from "./item.vue";
@Component({
  components: { item }
})
export default class itemlist extends Vue {
  demoArr: Array<ItemData> = this.$store.state.actionHelper.demoList;
  filterData() {
    if (this.$store.state.filterId == -1) {
      return this.demoArr.filter((e: any) => {
        return e.archive === false;
      });
    } else if (this.$store.state.filterId == -2) {
      return this.$store.state.actionHelper.demoList.filter((e: any) => {
        return e.archive === true;
      });
    } else {
      return this.$store.state.actionHelper.demoList.filter(
        (e: any, index: number) => {
          return (
            e.archive === false && e.categoryId === this.$store.state.filterId
          );
        }
      );
    }
  }
}
